import { Stack, DefaultButton, PrimaryButton } from '@fluentui/react';
import { useState } from 'react';
import "./CustomTabBar.css"

interface ICustomTabBarProps {
    tabGroupNames: string[],
    onSelectChange: (tabId: string) => void
}

interface MyObject {
    [key: string]: any;
  }

export default function CustomTabBar(props: ICustomTabBarProps) {

    const [tabGroupState, setTabGroupState] = useState(()=>{
        const state: MyObject = {}
        props.tabGroupNames.forEach((item,index) => {
            if(index === 0) {
                // display first type
                state[`${item.toLocaleLowerCase()}ButtonStyle`] = 'common_page_tab_bar_active'
                props.onSelectChange(item)
            }else {
                state[`${item.toLocaleLowerCase()}ButtonStyle`] = 'common_page_tab_bar_blur'
            }
        })
        state[Object.keys(state)[0]] = 'common_page_tab_bar_active'
        props.onSelectChange(props.tabGroupNames[0])
        return state
    })

    const getButtonClassName = (type: string): string => {
        return tabGroupState[`${type.toLocaleLowerCase()}ButtonStyle`]
    }

    const handleContentChange = (tabId: string) => {
        const activeProp = `${tabId.toLocaleLowerCase()}ButtonStyle`
        const newPartialState: MyObject = {}
        Object.keys(tabGroupState).forEach(key => {
            if(key === activeProp) {
                newPartialState[key] = 'common_page_tab_bar_active'
            }
            if(key !== activeProp && key.indexOf('ButtonStyle') > 0) {
                newPartialState[key] = 'common_page_tab_bar_blur'
            }
        }) 
        setTabGroupState({
            ...tabGroupState,
            ...newPartialState
        })
        props.onSelectChange(tabId)
    }

    return (
        <Stack horizontal tokens={{ childrenGap: 8 }} className="common_page_tab_bar">
            {props.tabGroupNames.map(item => (
                <DefaultButton
                    text={item}
                    key={item}
                    className={getButtonClassName(item)}
                    onClick={() => handleContentChange(item)}
                />
            ))}
        </Stack>
    )
}